module.exports = __webpack_public_path__ + "static/contribution_img1@2x-fae63b0b5a24f28074e952ba1f2776f1.jpg";